import type { FC } from "react";

import {
  AnimatedHorizontalRule,
} from "@/ui/components/layout/AnimatedHorizontalRule";
import { Container } from "@/ui/components/layout/Container";
import { Section } from "@/ui/components/layout/Section";
import { cn } from "@/ui/lib/utils";
import type {
  TAnimatedHeaderSectionProps,
} from "@/ui/components/layout/AnimatedHeaderSection";

export const AnimatedHeaderSection: FC<TAnimatedHeaderSectionProps> = (
  {
    illustration,
    background,
    className,
    containerClassName,
    children,
    ...props
  },
) => (
  <Section
    {...props}
    data-component="AnimatedHeaderSection"
    className={cn(className)}
  >
    <AnimatedHorizontalRule
      illustration={illustration}
      background={background}
    />
    <Container
      data-component="AnimatedHeaderSectionContainer"
      className={cn(containerClassName)}
    >
      { children }
    </Container>
  </Section>
);

AnimatedHeaderSection.displayName = "AnimatedHeaderSection";
